<template>
  <v-menu left
          max-width="500"
          :close-on-content-click="false"
          v-model="isMenuOpened">
    <template v-slot:activator="{ on }">
      <v-btn
        color="mainButtons"
        class="my-1 mr-2"
        outlined
        v-on="on"
      >
        {{ $t('general.columnsTable') }}
        <v-icon>mdi-chevron-down</v-icon>
      </v-btn>
    </template>

    <TableColumns
      :all-columns-prop="allColumnsProp"
      :is-component-opened="isMenuOpened"
      :loading="loading"
      :selected-columns-prop="selectedColumnsProp"
      v-show="isMenuOpened && !isMenuHiddenOnCreated"
      @closeComponent="closeMenu()"
      @onColumnsChange="onColumnsChange"
    />
  </v-menu>
</template>

<script>
import TableColumns from '@/components/widgets/TableColumns'
export default {
  components: {
    TableColumns
  },
  computed: {
    isMenuOpened: {
      get () {
        return this.isMenuOpenedProp
      },
      set (value) {
        this.$emit('toggleMenu', value)
      }
    }
  },
  methods: {
    closeMenu () {
      this.isMenuOpened = false
    },
    onColumnsChange (columns) {
      this.$emit('onColumnsChange', columns)
    }
  },
  props: {
    allColumnsProp: {
      type: Array,
      required: true
    },
    isMenuHiddenOnCreated: {
      type: Boolean,
      default: false
    },
    isMenuOpenedProp: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    selectedColumnsProp: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
  }
</style>
